document.addEventListener('DOMContentLoaded', function() {
    const likeDislikeContainer = document.querySelector('.like-dislike');
    
    if (likeDislikeContainer) {
        const postId = likeDislikeContainer.dataset.postId;
        const likeBtn = likeDislikeContainer.querySelector('.like');
        const dislikeBtn = likeDislikeContainer.querySelector('.dislike');
        const likeCount = likeDislikeContainer.querySelector('.like-count');
        const dislikeCount = likeDislikeContainer.querySelector('.dislike-count');
        const statusElement = likeDislikeContainer.querySelector('.vote-status');
        const feedbackMessage = likeDislikeContainer.parentElement.querySelector('.vote-feedback-message');

        // Cookie management functions
        function setCookie(name, value, days = 30) {
            const expires = new Date();
            expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
            document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
        }

        function getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

        function deleteCookie(name) {
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        }

        // Vote state management
        const votesCookieName = `post_votes_${postId}`;
        const votesTimestampName = `post_votes_timestamp_${postId}`;

        function saveVoteToStorage(voteType, likes, dislikes) {
            const voteData = {
                vote: voteType,
                likes: likes,
                dislikes: dislikes,
                timestamp: Date.now()
            };
            setCookie(votesCookieName, JSON.stringify(voteData), 30); // 30 days retention
            setCookie(votesTimestampName, Date.now(), 30);
        }

        function getVoteFromStorage() {
            try {
                const voteData = getCookie(votesCookieName);
                const timestamp = getCookie(votesTimestampName);
                
                if (voteData && timestamp) {
                    const parsedData = JSON.parse(voteData);
                    const voteAge = Date.now() - parseInt(timestamp);
                    const maxAge = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
                    
                    // Return vote if it's within retention period
                    if (voteAge < maxAge) {
                        return parsedData;
                    } else {
                        // Clean up expired vote
                        deleteCookie(votesCookieName);
                        deleteCookie(votesTimestampName);
                    }
                }
            } catch (e) {
                console.warn('Error reading vote from storage:', e);
                // Clean up corrupted data
                deleteCookie(votesCookieName);
                deleteCookie(votesTimestampName);
            }
            return null;
        }

        function clearVoteFromStorage() {
            deleteCookie(votesCookieName);
            deleteCookie(votesTimestampName);
        }

        function updateAriaLabels(likes, dislikes, userVote = null) {
            likeBtn.setAttribute('aria-label', `Like this article (currently ${likes} likes)${userVote === 'like' ? ' - You have liked this article' : ''}`);
            dislikeBtn.setAttribute('aria-label', `Dislike this article (currently ${dislikes} dislikes)${userVote === 'dislike' ? ' - You have disliked this article' : ''}`);
        }

        function announceToScreenReader(message) {
            statusElement.textContent = message;
            // Clear the message after screen readers have had time to announce it
            setTimeout(() => {
                statusElement.textContent = '';
            }, 1000);
        }

        function showFeedbackMessage(type, action) {
            let message = '';
            let className = '';
            
            if (type === 'voted') {
                if (action === 'like') {
                    message = "You've liked this article. Thanks for the feedback!";
                    className = 'like-feedback';
                } else if (action === 'dislike') {
                    message = "You've disliked this article. Thanks for the feedback!";
                    className = 'dislike-feedback';
                }
            } else if (type === 'removed') {
                message = "Your vote has been removed. Thanks for your feedback!";
                className = 'removed-feedback';
            }
            
            if (feedbackMessage && message) {
                // Clear any existing timeouts
                if (feedbackMessage.hideTimeout) {
                    clearTimeout(feedbackMessage.hideTimeout);
                    delete feedbackMessage.hideTimeout;
                }
                
                feedbackMessage.textContent = message;
                feedbackMessage.className = 'vote-feedback-message ' + className;
                feedbackMessage.style.display = 'block';
                feedbackMessage.style.opacity = '1';
            }
        }
        
        function hideFeedbackMessage() {
            if (feedbackMessage) {
                // Clear any existing timeouts
                if (feedbackMessage.hideTimeout) {
                    clearTimeout(feedbackMessage.hideTimeout);
                    delete feedbackMessage.hideTimeout;
                }
                
                feedbackMessage.style.opacity = '0';
                feedbackMessage.hideTimeout = setTimeout(() => {
                    feedbackMessage.style.display = 'none';
                    feedbackMessage.style.opacity = '1';
                    delete feedbackMessage.hideTimeout;
                }, 300);
            }
        }

        function updateUIState(likes, dislikes, userVote, showMessage = false) {
            // Update counts
            likeCount.textContent = likes;
            dislikeCount.textContent = dislikes;
            
            // Update visual state
            if (userVote === 'like') {
                likeBtn.classList.add('voted');
                dislikeBtn.classList.remove('voted');
                likeBtn.setAttribute('aria-pressed', 'true');
                dislikeBtn.setAttribute('aria-pressed', 'false');
                if (showMessage) {
                    announceToScreenReader(`You liked this article. Total likes: ${likes}`);
                    showFeedbackMessage('voted', 'like');
                }
            } else if (userVote === 'dislike') {
                dislikeBtn.classList.add('voted');
                likeBtn.classList.remove('voted');
                dislikeBtn.setAttribute('aria-pressed', 'true');
                likeBtn.setAttribute('aria-pressed', 'false');
                if (showMessage) {
                    announceToScreenReader(`You disliked this article. Total dislikes: ${dislikes}`);
                    showFeedbackMessage('voted', 'dislike');
                }
            } else {
                likeBtn.classList.remove('voted');
                dislikeBtn.classList.remove('voted');
                likeBtn.setAttribute('aria-pressed', 'false');
                dislikeBtn.setAttribute('aria-pressed', 'false');
                if (showMessage) {
                    announceToScreenReader(`Your vote has been removed.`);
                    hideFeedbackMessage();
                }
            }
            
            updateAriaLabels(likes, dislikes, userVote);
        }

        function handleVote(action) {
            // Prevent multiple rapid clicks
            likeBtn.disabled = true;
            dislikeBtn.disabled = true;
            likeBtn.setAttribute('aria-busy', 'true');
            dislikeBtn.setAttribute('aria-busy', 'true');

            fetch(ajax_object.ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'action': 'handle_post_vote',
                    'post_id': postId,
                    'vote_action': action,
                    'nonce': ajax_object.nonce
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Update UI and save to storage
                    updateUIState(data.data.likes, data.data.dislikes, data.data.user_vote, true);
                    
                    // Save vote state to cookie
                    if (data.data.user_vote) {
                        saveVoteToStorage(data.data.user_vote, data.data.likes, data.data.dislikes);
                    } else {
                        // Vote was removed
                        clearVoteFromStorage();
                    }
                } else {
                    announceToScreenReader('Sorry, there was an error processing your vote. Please try again.');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                announceToScreenReader('Sorry, there was an error processing your vote. Please try again.');
            })
            .finally(() => {
                // Re-enable buttons
                likeBtn.disabled = false;
                dislikeBtn.disabled = false;
                likeBtn.removeAttribute('aria-busy');
                dislikeBtn.removeAttribute('aria-busy');
            });
        }

        // Add keyboard support
        function handleKeydown(event, action) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleVote(action);
            }
        }

        // Initialize the component
        function initializeVoteState() {
            // Initialize aria-pressed state
            likeBtn.setAttribute('aria-pressed', 'false');
            dislikeBtn.setAttribute('aria-pressed', 'false');
            
            // Check for existing vote in storage
            const storedVote = getVoteFromStorage();
            if (storedVote) {
                // Restore the saved vote state silently (no feedback message)
                updateUIState(storedVote.likes, storedVote.dislikes, storedVote.vote, false);
                
                // Also restore the appropriate feedback message
                if (storedVote.vote === 'like') {
                    showFeedbackMessage('voted', 'like');
                } else if (storedVote.vote === 'dislike') {
                    showFeedbackMessage('voted', 'dislike');
                }
            }
        }

        // Event listeners
        likeBtn.addEventListener('click', () => handleVote('like'));
        dislikeBtn.addEventListener('click', () => handleVote('dislike'));
        
        // Keyboard event listeners
        likeBtn.addEventListener('keydown', (e) => handleKeydown(e, 'like'));
        dislikeBtn.addEventListener('keydown', (e) => handleKeydown(e, 'dislike'));
        
        // Initialize the vote state
        initializeVoteState();
    }
});
